import { ControlledModalFooter, ControlledModalHeader } from "@/components"
import { create } from "zustand"

export const CREATIVE_VALID_STEPS = ["profession", "image", "portfolio"] as const
type CreativeStep = (typeof CREATIVE_VALID_STEPS)[number]

export type InstagramFlowStore = {
  header: ControlledModalHeader
  setHeader: (header: ControlledModalHeader) => void
  footer: ControlledModalFooter
  setFooter: (footer: ControlledModalFooter) => void
}

export const useInstagramFlowStore = create<InstagramFlowStore>((set, get) => ({
  header: {
    title: "What is your Instagram handle?",
    subtitle: "Step 1/2",
    variant: "progress",
    fixed: true,
  },
  setHeader: (header: ControlledModalHeader) => {
    set(() => ({ header }))
  },
  footer: {
    fixed: true,
  },
  setFooter: (footer: ControlledModalFooter) => {
    set(() => ({ footer }))
  },
}))
